function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedBunkBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 2c-.55 0-1 .45-1 1v8c0-1.66-1.34-3-3-3H13c0-1.66-1.34-3-3-3H8C6.34 5 5 6.34 5 8v.78c-.61.55-1 1.34-1 2.22V3c0-.55-.45-1-1-1s-1 .45-1 1v27h2v-3h24v3h2V3c0-.55-.45-1-1-1zm-4 8c.55 0 1 .45 1 1v1H6v-1c0-.55.45-1 1-1h18zM8 7h2c.55 0 1 .45 1 1H7c0-.55.45-1 1-1zM7 21c0-.55.45-1 1-1h2c.55 0 1 .45 1 1H7zm-1 3c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v1H6v-1zm22 0c0-1.66-1.34-3-3-3H13c0-1.66-1.34-3-3-3H8c-1.66 0-3 1.34-3 3v.78c-.61.55-1 1.34-1 2.22V14h24v10z",
    fill: props.color
  }));
}

export default SvgIconBedBunkBedFilled;